import React, { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Collapse, IconButton, Typography } from '@mui/material';

/**
 * @param {{ title: string, children: React.ReactNode, defaultOpen?: boolean }} props
 */
export function SettingsCollapsibleGroup({
  title,
  children,
  defaultOpen = false,
}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <Box
      sx={{
        mb: 1,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1.5,
        overflow: 'hidden',
      }}
    >
      <Box
        component="button"
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          m: 0,
          px: 1.25,
          py: 0.85,
          border: 'none',
          bgcolor: 'action.hover',
          color: 'text.primary',
          cursor: 'pointer',
          textAlign: 'left',
          font: 'inherit',
          WebkitTapHighlightColor: 'transparent',
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: 700 }}>
          {title}
        </Typography>
        <IconButton
          size="small"
          tabIndex={-1}
          aria-hidden
          sx={{
            p: 0.25,
            transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.15s ease',
          }}
        >
          <ExpandMoreIcon fontSize="small" />
        </IconButton>
      </Box>
      <Collapse in={open}>
        <Box sx={{ px: 1.25, pt: 1, pb: 1.25 }}>{children}</Box>
      </Collapse>
    </Box>
  );
}
